import React, { useEffect, useState } from "react";
import BasicTimePicker from "../../../components/common/TimePick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useDispatch, useSelector } from "react-redux";
import AllProfessionalServicesList from "./AllProfessionalServicesList";
import { useNavigate } from "react-router-dom";
import ProfessionalBanner from "../../../components/common/ProfessionalBanner";
import DatePick from "../../../components/common/DatePick";
import { getAllServicedData, setAdditionalComments, setPreferredDates, setSelectCategory } from "../../../redux/reducers/createOrderSlice";
import { toast } from "react-toastify";
import DropDownForTimeSelection from "../GeneralRegularBooking/DropDownForTimeSelection";
import DropDownDurationProfessional from "../GeneralRegularBooking/DropDownDurationProfessional";

const Professional = () => {
  // Hooks Call
  const dispatch = useDispatch(), navigate = useNavigate()

  // Stores 
  const { professionalServiceAllList, preferredDates, professionalServiceAllFilesForUiShow, compalsaryMediaUpload, selectedAddress } = useSelector((state) => state.createOrderSlice)
  const { user } = useSelector((state) => state.auth)
  const [agreeTerms, setAgreeTerms] = useState(false)


  // States
  const optionsForProfTimeRange = [
    {
      startTime: {
        hours: 9,
        minutes: 0,
        seconds: 0
      }
    },
    {
      startTime: {
        hours: 14,
        minutes: 30,
        seconds: 0
      }
    },
    {
      startTime: {
        hours: 19,
        minutes: 0,
        seconds: 0
      }
    }
  ]
  // Functions

  const handlePreferredDates = (index, value, type) => {
    let newArr = [...preferredDates]
    if (type === 'time') {
      let newDate = new Date(value)
      let oldDate = new Date(newArr[index])

      oldDate.setHours(newDate?.getHours())
      oldDate.setMinutes(newDate?.getMinutes())
      newArr[index] = oldDate.toISOString()
    }
    else {
      let setvalue = new Date(value)
      setvalue.setHours(9)
      setvalue.setMinutes(0)
      newArr[index] = setvalue.toISOString()
    }

    dispatch(setPreferredDates({ preferredDates: newArr }))
  }
  const handleAdditionalComment = (e) => {
    dispatch(
      setAdditionalComments({ additionalComments: e.target.value })
    )
  }

  const gotoCheckOut = () => {
    if (professionalServiceAllFilesForUiShow?.length === 0) {
      toast.error('Please Select at least one service')
    } else if (preferredDates?.length === 0) {
      toast.error('Please Select at least one date and time')
    } else if (!agreeTerms) {
        toast.error("Please confirm that you understand the cleaning supplies policy.");
    }
    else {
      if (professionalServiceAllFilesForUiShow?.length >= Array.from(new Set(compalsaryMediaUpload))?.length) {
        navigate('/checkout')
      }
      else {
        toast.error('Please select media file for required services')
        let filteredArray = professionalServiceAllFilesForUiShow?.map(item => item?.serviceId)
        for (let item of Array.from(new Set(compalsaryMediaUpload))) {
          if (!filteredArray.includes(item)) {
            let elem = document.getElementById(item);
            elem.scrollIntoView({
              block: "center"
            });
            break;
          }
        }

      }
    }
  }
  // UseEffects

  useEffect(() => {
    dispatch(getAllServicedData())
  }, [])


  useEffect(() => {
    dispatch(setSelectCategory({ selectedCategory: 'Professional' }))
  }, [])
  useEffect(() => {
    if (!selectedAddress) {
      if (!user) {
        navigate('/')
      }
      else {
        navigate('/dashboard')
      }
    }

  }, [selectedAddress])
  return (
    <>
      <div className="pro-acc-wrap max-720">
        <ProfessionalBanner />
        <h5>Select one or more services</h5>
        {professionalServiceAllList?.length > 0 && professionalServiceAllList?.map((item, idx) => {
          return (
            <>
              <AllProfessionalServicesList item={item} idx={idx} />
            </>
          )
        })}
        <div className="acc-body-wrap uplo mb-4">
          <h6>Select Date and Time:</h6>
          <div className="uplorow-main">
            <p>Preferred date and time:</p>
            <div className="row">
              <div className="col-md-6 time-pick-wrap">
                <DatePick handlePreferredDates={handlePreferredDates} index={0} preferredDates={preferredDates[0]} />
              </div>
              <div className="col-md-6 time-pick-wrap prof-time-picker">
                {/* <BasicTimePicker disabled={!preferredDates[0]} handlePreferredDates={handlePreferredDates} index={0} label="Basic time picker" preferredTime={preferredDates[0]} /> */}
                <DropDownDurationProfessional
                  disableCondition={!preferredDates[0]}
                  options={optionsForProfTimeRange}
                  onChange={(val) => {
                    handlePreferredDates(0, new Date(0, 0, 0, val?.startTime?.hours, val?.startTime?.minutes, val?.startTime?.seconds)?.toISOString(), 'time')
                  }
                  }
                  index={0}
                />
              </div>
            </div>
          </div>
          <div className="uplorow-main">
            <p>1st Alternate date and time:</p>
            <div className="row">
              <div className="col-md-6 time-pick-wrap">
                <DatePick handlePreferredDates={handlePreferredDates} index={1} preferredDates={preferredDates[1]} />
              </div>
              <div className="col-md-6 time-pick-wrap prof-time-picker">
                {/* <BasicTimePicker disabled={!preferredDates[0]} handlePreferredDates={handlePreferredDates} index={0} label="Basic time picker" preferredTime={preferredDates[0]} /> */}
                <DropDownDurationProfessional
                  disableCondition={!preferredDates[1]}
                  options={optionsForProfTimeRange}
                  onChange={(val) => {
                    handlePreferredDates(1, new Date(0, 0, 0, val?.startTime?.hours, val?.startTime?.minutes, val?.startTime?.seconds)?.toISOString(), 'time')
                  }
                  }
                  index={1}
                />
              </div>
            </div>
          </div>
          <div className="uplorow-main">
            <p>2nd Alternate date and time:</p>
            <div className="row">
              <div className="col-md-6 time-pick-wrap">
                <DatePick handlePreferredDates={handlePreferredDates} index={2} preferredDates={preferredDates[2]} />
              </div>
              <div className="col-md-6 time-pick-wrap prof-time-picker">
                {/* <BasicTimePicker disabled={!preferredDates[0]} handlePreferredDates={handlePreferredDates} index={0} label="Basic time picker" preferredTime={preferredDates[0]} /> */}
                <DropDownDurationProfessional
                  disableCondition={!preferredDates[2]}
                  options={optionsForProfTimeRange}
                  onChange={(val) => {
                    handlePreferredDates(2, new Date(0, 0, 0, val?.startTime?.hours, val?.startTime?.minutes, val?.startTime?.seconds)?.toISOString(), 'time')
                  }
                  }
                  index={2}
                />
              </div>
            </div>
          </div>
          <div className="remark-sec pro-textarea">
            <div className="textarea-bottom">
              <label>Additional instruction or remark:</label>
              <textarea className="form-control" onChange={handleAdditionalComment}></textarea>
              <div className="form-check mt-2">
                <input
                  type="checkbox"
                  id="agreeTerms"
                  className="form-check-input"
                  checked={agreeTerms}
                  onChange={(e) => setAgreeTerms(e.target.checked)}
                />
                <label htmlFor="agreeTerms" className="form-check-label additional-text">
                  I understand that general / regular cleaning does not include cleaning supplies.
                </label>
              </div>
            </div>
            <div className="button-right">
              <button onClick={gotoCheckOut} className="btn">
                Next
                <FontAwesomeIcon icon={icon({ name: "angle-right" })} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Professional;
